import { httpClient } from "./httpClient";

type EmployeeDelegate = {
  id: number;
  userEmail: string;
  delegateEmail: string;
  isActive: boolean;
  dateAdded: Date;
  cEmployees_fk: number;
  startDate: Date;
  endDate: Date;
};

export async function getEmployeeDelegates(
  employeeId: number
): Promise<EmployeeDelegate[]> {
  try {
    const { data } = await httpClient.get<EmployeeDelegate[]>(
      `/api/v1/employeedelegatesbyemployeeid/${employeeId}`
    );

    return data;
  } catch (e) {
    throw e;
  }
}
